// Disponibiliza o cliente tipado da API (único caminho HTTP da SPA — `giyus/no-raw-fetch`).
import { type ReactNode, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import type { AuthBackend } from '../auth/types';
import { ApiClientContext } from './apiClientContext';
import { buildApiClient } from './buildApiClient';

export interface ApiClientProviderProps {
  readonly baseUrl: string;
  readonly backend: AuthBackend;
  readonly children: ReactNode;
}

export function ApiClientProvider({ baseUrl, backend, children }: ApiClientProviderProps) {
  const { i18n } = useTranslation();
  // A função lê `i18n.resolvedLanguage` a cada requisição: a troca de idioma vale na chamada seguinte (REQ-FE-005).
  const client = useMemo(
    () => buildApiClient(baseUrl, backend, () => i18n.resolvedLanguage ?? i18n.language),
    [baseUrl, backend, i18n],
  );
  return <ApiClientContext value={client}>{children}</ApiClientContext>;
}
